/**
 * Handles clicks on custom [data-popup-id] buttons and opens the corresponding
 * Bricks popup via the Bricks JS API.
 *
 * @param {Document|Element} scope
 */
export function initPopupTrigger(scope) {
  scope.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-popup-id]');
    if (!btn) return;
    if (btn.classList.contains('brx-popup')) return;

    const popupId = btn.dataset.popupId;
    if (!popupId) return;

    const popupIdInt = parseInt(popupId, 10);
    if (typeof window.bricksOpenPopup === 'function' && !Number.isNaN(popupIdInt)) {
      window.bricksOpenPopup(popupIdInt);
      return;
    }

    // Fallback for setups without bricksOpenPopup helper.
    document.dispatchEvent(
      new CustomEvent('bricks/popup/open', {
        detail: { popupId },
      })
    );
  });
}
